/* Keep the last chosen navigation control underlined across filter reloads. */
(() => {
 if (window.sweetbarCollectionTrailReady) return;
 window.sweetbarCollectionTrailReady = true;
 const scope = '.sb-collection-trail, .sb-mobile-trail';
 const key = 'sweetbar-trail:' + (location.pathname.match(/\/collections\/([^/]+)/)?.[1] || 'all');
 let active = '';
 try { active = sessionStorage.getItem(key) || ''; } catch (_) {}
 if (!['home','flavor','sort'].includes(active)) active = '';
 const apply = value => {
  document.documentElement.dataset.sbTrailActive = value;
  try { sessionStorage.setItem(key, value); } catch (_) {}
 };
 apply(active);
 const update = event => {
  const target = event.target;
  if (!(target instanceof Element) || !target.closest(scope)) return;
  if (target.closest('.sb-trail-home')) apply('home');
  else if (target.matches('[data-sb-flavor-select]')) apply('flavor');
  else if (target.matches('select[name="sort_by"]')) apply('sort');
 };
 document.addEventListener('pointerdown', update, true);
 document.addEventListener('focusin', update, true);
 document.addEventListener('change', update, true);
})();

